import { ChildrenItem } from "dependencies/base"
import { Map } from "./model"
import { differentOpt } from "./difference_options"
import { home_differentOpt } from "./home_difference_options"
import icon from "assets/images/leftMenu/chart/cx_map.png"
// import homeIcon from "assets/images/homeLeftMenu/chart/icon_map.png"
import {HomeLine, Line} from "../../line/menus/model";
let homeIcon = "icon-portal-map"
let cover = [
  require("toolbarComponents/bigScreen/image/map1.png")
]
export let map_children = []
export let home_map_children = []
for (let i = 0; i < differentOpt.length; i++) {
  map_children.push(new ChildrenItem("地图样式" + i, icon, "cxRealMap", new Map(differentOpt[i])))
}

for (let i = 0; i < home_differentOpt.length; i++) {
  home_map_children.push(new ChildrenItem("地图样式" + i, homeIcon, "cxRealMap", new Map(home_differentOpt[i]),cover[i]))
}